// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"fc07ae5af48139f57d41","112":"35f0546a4edc870a7bef","113":"6f4d6a9cd68e6203e674","161":"5714247fc6651ee64626"}[chunkId] + ".chunk.js";
};